import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';

@Injectable()
export class AuthInterceptor implements HttpInterceptor
{
    /**
     * Constructor
     */
    constructor(private _authService: AuthService)
    {
    }


     getBrowserNameAndVersion() {
  const userAgent = navigator.userAgent;
  let browserName = "Unknown";
  let version = "";

  if (userAgent.includes("Edg/")) {
    browserName = "Edge";
    version = userAgent.match(/Edg\/([\d\.]+)/)?.[1];
  } else if (userAgent.includes("Chrome/")) {
    browserName = "Chrome";
    version = userAgent.match(/Chrome\/([\d\.]+)/)?.[1];
  } else if (userAgent.includes("Safari/") && !userAgent.includes("Chrome")) {
    browserName = "Safari";
    version = userAgent.match(/Version\/([\d\.]+)/)?.[1];
  } else if (userAgent.includes("Firefox/")) {
    browserName = "Firefox";
    version = userAgent.match(/Firefox\/([\d\.]+)/)?.[1];
  } else if (userAgent.includes("MSIE")) {
    browserName = "Internet Explorer";
    version = userAgent.match(/MSIE ([\d\.]+)/)?.[1];
  } else if (userAgent.includes("Trident/")) {
    browserName = "Internet Explorer";
    version = userAgent.match(/rv:([\d\.]+)/)?.[1];
  }

  return `${browserName} ${version}`;
}

 
    /**
     * Intercept
     *
     * @param req
     * @param next
     */
     intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Get token from AuthService (work with OAuth)
        const token = this._authService.accessToken;
        
        if (token) {
            const authReq = req.clone({
                headers: req.headers.set('Authorization', `Bearer ${token}`)
            });
            return next.handle(authReq);
        }
        
        return next.handle(req);
    }
}
